import React from "react";
import styled from "styled-components";

const Cite = styled.cite`
  background: ${props => 'url(' + props.bg + ')'} center top no-repeat;
  background-size: 80px;
  display: inline-block;
  font-family: Helvetica;
  font-size: 22px;
  color: #505663;
  line-height: 32px;
  width: 100%;
  padding-top: 85px;
`;

export default Cite;



// WEBPACK FOOTER //
// ./src/styled-components/Cite.js